import { render, staticRenderFns } from "./SpoiledLocation.vue?vue&type=template&id=18a3975f&scoped=true&"
import script from "./SpoiledLocation.vue?vue&type=script&lang=js&"
export * from "./SpoiledLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3975f",
  null
  
)

export default component.exports